import { FC, useReducer } from 'react';
import { MigrationFlowContext } from './context';
import { initialMigrationState } from './MigrationFlowData';
import { migrationReducer } from './reducer';

export const MigrationFlowContextProvider: FC = ({ children }) => {
  const [state, dispatch] = useReducer(migrationReducer, initialMigrationState);

  return <MigrationFlowContext.Provider value={{ state, dispatch }}>{children}</MigrationFlowContext.Provider>;
};
